<template>
    <div class="body flex">
        <div class="cover">
            <van-image
                class="cover-img"
                radius="5px"
                width="24vw"
                height="24vw"
                fit="cover"
                :src="music.cover"
            />
        </div>

        <div class="content">
            <div class="name subtitle">{{music.name || music.title}}</div>

            <div class="intr font-gray">{{getIntr || music.description}}</div>

            <div class="date font-gray">{{music.date}}</div>
        </div>

        <div class="detail" @click="onDetail">
            <van-icon name="ellipsis" class="detail-icon" />
        </div>
    </div>
</template>

<script>
import { ellipsisString } from '@/utils/stringUtils'
import { Toast } from 'vant'

export default {
    name: 'MusicItem',
    props: {
        music: {
            type: Object,
            default: () => {
                return {
                    cover:'',
                    name: '',
                    intr: '',
                    date: ''
                }
            }
        }
    },
    computed: {
        getIntr() {
            return ellipsisString(this.music.intr, 13)
        }
    },
    methods: {
        onDetail() {
            Toast.fail('TODO')
        }
    }
}
</script>

<style scoped>
.font-gray {
    font-size: 14px;
    color: #4E4E4E;
}

.cover-img {
    box-shadow: 0 0 10px rgba(56, 56, 56, 0.2);
}

.content {
    width: 62.7vw;
    box-sizing: border-box;
    padding: 10px 20px;
    position: relative;
}

.date {
    position: absolute;
    bottom: 10px;
}

.detail {
    width: 6.9vw;
    line-height: 24vw;
    font-size: 18px;
}

.detail-icon {
    font-weight: 700;
}
</style>

